import { createContext, type ReactNode } from "react"

type GlobalUIContextType = Record<string, never>

const GlobalUIContext = createContext<GlobalUIContextType | null>(null)

interface GlobalUIProviderProps {
  children: ReactNode
}

export function GlobalUIProvider({ children }: GlobalUIProviderProps) {
  return <GlobalUIContext.Provider value={{}}>{children}</GlobalUIContext.Provider>
}
